import React, { useState } from "react";
import FeatherIcon from "feather-icons-react";
import Checkbox from "../../../common/form_elements/checkbox";
import Select from "../../../common/form_elements/select";
import Input from "../../../common/form_elements/input";

const CompareOptions = ({ isStep, step2 }) => {
  return (
    <>
      {/* Step 2 */}
      <div
        className={`upload__item ${isStep === 2 ? " d_block" : " d_none"}`}
        ref={step2}
      >
        <div className="upload__category">Other Settings</div>
        <div className="upload__note">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolores,
          provident?
        </div>
        <div className="upload__fieldset">
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Select
                label="Product Category"
                options={["All", "Home exercise equipment", "Electronics"]}
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="max_product"
                name="max_product"
                label="Max Product Number"
                type="number"
                placeholder="e.g. 1000"
              />
            </div>
          </div>
          <div className="upload__category mm">Core features</div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="amz_seller_min"
                name="amz_seller_min"
                label="Amazon Seller Number"
                type="number"
                placeholder="Min."
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="amz_seller_max"
                name="amz_seller_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="prime_seller_min"
                name="prime_seller_min"
                label="Prime (FBA) Seller Number"
                type="number"
                placeholder="Min."
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="prime_seller_max"
                name="prime_seller_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="mfn_seller_min"
                name="mfn_seller_min"
                label="MFN (FBM) Seller Number"
                type="number"
                placeholder="Min."
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="mfn_seller_max"
                name="mfn_seller_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="sales_rank_min"
                name="sales_rank_min"
                label="Sales Rank"
                type="number"
                placeholder="Min."
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="sales_rank_max"
                name="sales_rank_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="roi_min"
                name="roi_min"
                label="Roi"
                type="number"
                placeholder="Min."
                customClass="field_map"
                fieldMap="%"
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="roi_max"
                name="roi_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
                customClass="field_map"
                fieldMap="%"
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="price_min"
                name="price_min"
                label="Price"
                type="number"
                placeholder="Min."
                customClass="field_map"
                fieldMap="$"
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="price_max"
                name="price_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
                customClass="field_map"
                fieldMap="$"
              />
            </div>
          </div>
          <div className="upload__row">
            <div className="upload__col upload__col_w33">
              <Input
                id="stock_min"
                name="stock_min"
                label="Stock Number"
                type="number"
                placeholder="Min."
              />
            </div>
            <div className="upload__col upload__col_w33">
              <Input
                id="stock_max"
                name="stock_max"
                label="&nbsp;&nbsp;"
                type="number"
                placeholder="Max."
              />
            </div>
          </div>
          <div className="upload__category mm">More features</div>
          <div className="upload__row">
            <div className="upload__col upload__col_w100">
              <Checkbox label="Custom option" defaultChecked={true} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompareOptions;
